import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.75 9L7.42857 6M4.57143 6L1.25002 9M1 3.5L5.08246 6.35772C5.41304 6.58913 5.57834 6.70484 5.75813 6.74965C5.91695 6.78924 6.08305 6.78924 6.24187 6.74965C6.42166 6.70484 6.58695 6.58913 6.91754 6.35772L11 3.5M3.4 10H8.6C9.44008 10 9.86012 10 10.181 9.83651C10.4632 9.6927 10.6927 9.46323 10.8365 9.18099C11 8.86012 11 8.44008 11 7.6V4.4C11 3.55992 11 3.13988 10.8365 2.81901C10.6927 2.53677 10.4632 2.3073 10.181 2.16349C9.86012 2 9.44008 2 8.6 2H3.4C2.55992 2 2.13988 2 1.81901 2.16349C1.53677 2.3073 1.3073 2.53677 1.16349 2.81901C1 3.13988 1 3.55992 1 4.4V7.6C1 8.44008 1 8.86012 1.16349 9.18099C1.3073 9.46323 1.53677 9.6927 1.81901 9.83651C2.13988 10 2.55992 10 3.4 10Z",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMail;
